import React from "react";
import { ValidationContainer } from "./ValidationRenderer.styles";
import { ClientQuestionRenderer } from "./ClientQuestionRenderer/ClientQuestionRenderer";
import { CandidateQuestionsRenderer } from "./CandidateQuestionsRenderer/CandidateQuestionsRenderer";

export const ValidationRenderer = ({ data, t }) => {
  if (!data) return null;

  // Get bestMatchIndex and explanation from the response data
  let bestMatchIndex = -1;
  let explanation = "";
  let isSimilar = false;

  try {
    // Check for different formats of the response
    if (typeof data.bestMatchIndex !== "undefined") {
      bestMatchIndex = parseInt(data.bestMatchIndex, 10);
    }

    if (data.explanation) {
      explanation = data.explanation;
    }

    // Check if isSimilar is defined
    if (typeof data.isSimilar !== "undefined") {
      isSimilar = Boolean(data.isSimilar);
    }
  } catch (e) {
    console.error("Error parsing validation data:", e);
  }

  return (
    <ValidationContainer>
      <ClientQuestionRenderer
        question={data.clientQuestion || ""}
        isMatched={isSimilar}
        t={t}
      />
      <CandidateQuestionsRenderer
        questions={data.candidateQuestions}
        bestMatchIndex={bestMatchIndex}
        explanation={explanation}
        t={t}
      />
    </ValidationContainer>
  );
};
